// Página Chá de Lingerie (Dear Bride): abas, fotos, botão fixo e quiz.
(() => {

// Abas de vantagens (no desktop os dois painéis aparecem lado a lado, via CSS)
const tabs = [...document.querySelectorAll('[role=tab]')];
const selectTab = (tab) => tabs.forEach((t) => {
  t.setAttribute('aria-selected', String(t === tab));
  document.getElementById(t.getAttribute('aria-controls')).hidden = t !== tab;
});
tabs.forEach((t) => t.addEventListener('click', () => selectTab(t)));
selectTab(tabs[0]);

// Fotos entram com fade quando chegam na tela
const fadeIo = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.remove('is-waiting'); fadeIo.unobserve(e.target); }
  });
}, { rootMargin: '0px 0px -6% 0px' });
document.querySelectorAll('.fade').forEach((el) => { el.classList.add('is-waiting'); fadeIo.observe(el); });

// Botão fixo no celular: aparece depois do hero e some quando o formulário ou o rodapé da loja estão na tela
const sticky = document.getElementById('stickybar');
const inView = new Set();
const stickyIo = new IntersectionObserver((entries) => {
  entries.forEach((e) => (e.isIntersecting ? inView.add(e.target) : inView.delete(e.target)));
  sticky.hidden = inView.size > 0;
});
[document.getElementById('hero-actions'), document.getElementById('organizar'), document.querySelector('.shopify-section--footer')]
  .filter(Boolean).forEach((el) => stickyIo.observe(el));

// Formulário em dois passos; no fim monta a mensagem e abre o WhatsApp da loja
const form = document.getElementById('form');
const error = document.getElementById('form-error');
const stepLabel = document.getElementById('form-step');
const pages = [...form.querySelectorAll('.cl-form__page')];
const today = new Date();
form.data.min = new Date(today - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

function showStep(n) {
  pages.forEach((p) => { p.hidden = p.dataset.step !== String(n); });
  stepLabel.textContent = `Passo ${n} de 2`;
  error.hidden = true;
}

// Marca os campos inválidos e devolve o primeiro, ou undefined se estiver tudo certo
function firstInvalid(fields) {
  fields.forEach((f) => f.setAttribute('aria-invalid', String(!f.checkValidity())));
  const bad = fields.find((f) => !f.checkValidity());
  if (bad) {
    error.textContent = bad === form.data && form.data.value
      ? 'A data do chá precisa ser de hoje em diante.'
      : bad === form.contato && form.contato.value
        ? 'Confira o contato: WhatsApp com DDD ou um e-mail válido.'
        : 'Preencha os campos destacados para a gente conseguir te responder.';
    error.hidden = false;
    bad.focus();
  }
  return bad;
}

function buildMessage(d) {
  const [y, m, day] = d.data.split('-');
  const estilo = [d.estilos.join(', '), d.obs].filter(Boolean).join(' — ');
  return [
    'Olá! Quero organizar um chá de lingerie com a Uiara.',
    '',
    `Noiva: ${d.noiva}`,
    `Estilo: ${estilo || 'a definir'}`,
    `Data do chá: ${day}/${m}/${y}`,
    `Amiga responsável: ${d.amiga}`,
    `Contato: ${d.contato}`,
  ].join('\n');
}

document.getElementById('form-next').addEventListener('click', () => {
  if (firstInvalid([form.noiva])) return;
  showStep(2);
  form.data.focus({ preventScroll: true });
});
document.getElementById('form-back').addEventListener('click', () => showStep(1));

form.addEventListener('submit', (e) => {
  e.preventDefault();
  if (!form.noiva.checkValidity()) { showStep(1); firstInvalid([form.noiva]); return; }
  if (firstInvalid([form.data, form.amiga, form.contato])) return;
  error.hidden = true;
  const msg = buildMessage({
    noiva: form.noiva.value.trim(),
    estilos: [...form.querySelectorAll('[name=estilo]:checked')].map((c) => c.value),
    obs: form.estilo_obs.value.trim(),
    data: form.data.value,
    amiga: form.amiga.value.trim(),
    contato: form.contato.value.trim(),
  });
  window.open(`https://wa.me/${form.dataset.whatsapp}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
});
showStep(1);

// O quiz abre no botão "Quero preencher o quiz!" ou em qualquer link que leve até ele
const quizOpen = document.getElementById('quiz-open');
const openQuiz = () => { form.hidden = false; quizOpen.hidden = true; };
form.hidden = true;
quizOpen.addEventListener('click', () => { openQuiz(); form.noiva.focus({ preventScroll: true }); });
document.querySelectorAll('a[href="#organizar"]').forEach((a) => a.addEventListener('click', openQuiz));

// Checagem: abra a página com ?selftest e veja o console
if (location.search.includes('selftest')) {
  const m = buildMessage({ noiva: 'Ana', estilos: ['Romântica e delicada', 'Sexy e autêntica'], obs: '', data: '2026-12-05', amiga: 'Bia', contato: '31 99999-0000' });
  console.assert(m.includes('Data do chá: 05/12/2026'), 'data em formato BR');
  console.assert(m.includes('Estilo: Romântica e delicada, Sexy e autêntica'), 'estilos listados');
  console.assert(buildMessage({ noiva: 'A', estilos: [], obs: '', data: '2026-01-02', amiga: 'B', contato: '1' }).includes('Estilo: a definir'), 'estilo vazio');
  const re = new RegExp(`^(?:${form.contato.pattern})$`, 'v'); // 'v' é como o navegador compila o pattern
  console.assert(re.test('(31) 99999-0000') && re.test('bia@email.com'), 'contato aceita WhatsApp ou e-mail');
  console.assert(!re.test('bia') && !re.test('3199'), 'contato recusa valor incompleto');
  console.log('selftest ok');
}
})();
